module.exports = __webpack_public_path__ + "roboto-regular-webfont-3ec24f953ed5e859a6402cb3c030ea8b.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-regular-webfont.woff2
// module id = 872
// module chunks = 88